import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Construct} from 'classes/construct';
import {ConstructsDetailsRepository} from '../repositories/constructs-details.repository';

@Injectable()
export class ConstructsDetailsService {

  constructor(private detailsRepo: ConstructsDetailsRepository) { }

  public getConstructById(id: number): Observable<Construct> {
    return this.detailsRepo.getConstructById(id);
  }

  public getConstructCloneById(id: number): Observable<Construct> {
    return this.getConstructById(id)
      .map((construct: Construct) => {
        delete construct._id;
        for (const question of construct.questions) {
          delete question._id;
        }

        return construct;
      });
  }

  public saveConstruct(construct: Construct): Observable<Construct> {
    return this.detailsRepo.saveConstruct(construct);
  }

  public updateConstruct(construct: Construct): Observable<Construct> {
    return this.detailsRepo.updateConstruct(construct);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/constructs/constructs-details/services/constructs-details.service.ts